<template>
  <div class="group-artic-detail">
    <a-form labelAlign="left" :form="form">
      <a-row type="flex" justify="start">
        <a-col :span="11">
          <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" label="ID：">
            <a-input :disabled="true" class="value-input" v-model="form.id" />
          </a-form-item>
        </a-col>
        <a-col :span="13">
          <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" label="标题：">
            <div>
              <a-input class="value-input" v-model="form.title" />
              <a-button type="primary" class="btn-color-warning" @click="checkFail('title')">敏感词检测</a-button>
            </div>
            <div v-if="warnTitle.status" v-html="warnTitle.content">
            </div>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row type="flex" justify="start">
        <a-col :span="11">
          <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" label="发布人：">
            <a-input :disabled="true" class="value-input" v-model="form.issue_name" />
          </a-form-item>
        </a-col>
        <a-col :span="13">
          <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" label="话题：">
            <a-input :disabled="true" class="value-input" v-model="form.labels" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row type="flex" justify="start">
        <a-col :span="11">
          <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" label="置顶类型：">
            <a-select :disabled="true" allowClear v-model="form.top_type" class="value-input">
              <a-select-option
                v-for="item in label.data.POSTS.TOP_TYPE"
                :key="item.key"
                :value="item.key"
                :title="item.value"
              >
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="13">
          <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" label="发布时间：">
            <a-input :disabled="true" class="value-input" v-model="formatTime " />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row type="flex" justify="start">
        <a-col :span="11">
          <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" label="评论数：">
            <a-input :disabled="true" class="value-input" v-model="form.comment" />
          </a-form-item>
        </a-col>
        <a-col :span="13">
          <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" label="点赞数：">
            <a-input :disabled="true" class="value-input" v-model="form.click_like" />
          </a-form-item>
        </a-col>
        <a-col :span="11">
          <a-form-item :label-col="{ span: 2 }" :wrapper-col="{ span: 12 }" label="审核状态：">
            <a-select :disabled="true" allowClear v-model="form.check_status" class="value-input">
              <a-select-option
                v-for="item in label.data.POSTS.CHECK_STATUS"
                :key="item.key"
                :value="item.key"
                :title="item.value"
              >
                {{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row type="flex" justify="start">
        <a-col :span="24">
          <a-form-item :label-col="{ span: 1 }" :wrapper-col="{ span: 21 }" label="内容">
            <a-textarea :autoSize="{ minRows: 6, maxRows: 12 }" class="value-input-tetxtarea" v-model="form.content" />
            <a-button type="primary" class="btn-color-warning" @click="checkFail('content')">敏感词检测</a-button>
            <div v-if="warnContent.status" v-html="warnContent.content">
            </div>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-spin :spinning="spinning"></a-spin>
    <div class="files-container">
      <file-item
        @delItem="delItem"
        v-for="(item, index) in form.attachment_urls"
        :key="index"
        :index="index"
        :src="item"
        :isImg="isImg"
      />
    </div>
    <div class="bottom-btn">
      <a-button @click="submit" type="primary">保存</a-button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import { forbiddenWordsArticle } from '@/api/article/list.js'
import fileItem from './components/fileItem.vue'
import { artDetail, editArt } from '@/api/groupWeb/article.js'
import { mapState } from 'vuex'
export default {
  components: { fileItem },
  computed: {
    ...mapState(['label']),
    formatTime() {
      return this.form.created_at ? moment(this.form.created_at * 1000).format('YYYY-MM-DD HH:mm:ss') : '--'
    },
  },
  data() {
    return {
      warnContent: {
        status: false,
        content: ''
      },
      warnTitle: {
        status: false,
        content: ''
      },
      spinning: false,
      form: {
        attachment_urls: [],
      },
      isImg: true,
    }
  },
  methods: {
    submit() {
      const params = _.cloneDeep(this.form)
      params.attachment_urls = params.attachment_urls.join(',')
      editArt(this.form).then((res) => {
        if (res.code === '000000') {
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      })
    },
    noneInfo(key) { // 无违禁词
      key === 'title' ? this.warnTitle.status = false : this.warnContent.status = false
    },
    warningExist(key, content) { // 有违禁词
      if (key === 'title') {
        this.warnTitle.content = content
        this.warnTitle.status = true
      } else {
        this.warnContent.content = content
        this.warnContent.status = true
      }
    },
    async checkFail(key) {
      if (!this.form[key]) {
        this.noneInfo(key)
        this.$message.warning('请输入内容')
        return
      }
      const params = {
        content: this.form[key],
      }
      const { data } = await forbiddenWordsArticle(params)
      if (data.content.indexOf('color:#F00') === -1) {
        this.noneInfo(key)
        this.$message.success('无违禁词')
      } else {
        this.warningExist(key, data.content)
        this.$message.warning('存在为违禁词')
      }
    },
    delItem(index) {
      this.form.attachment_urls.splice(index, 1)
    },
    typeofData(item) {
      const picture = ['.png', '.jpeg', '.jpg']
      const type = item.slice(item.lastIndexOf('.')).toLocaleLowerCase()
      return picture.includes(type)
    },
    async getInfo() {
      this.spinning = true
      try {
        const { data } = await artDetail(this.$route.params.id)
        const attachment_urls = []
        data.attachment_urls = data.attachment_urls.split(',')
        this.form = data || { attachment_urls }
        this.isImg = this.typeofData(this.form?.attachment_urls[0])
        this.spinning = false
      } catch {
        this.spinning = false
      }
    },
  },
  mounted() {
    this.getInfo()
  },
}
</script>

<style lang="less" scoped>
@input_width: 290px;
.group-artic-detail {
  overflow: auto;
  padding-bottom: 50px;
  .value-input {
    max-width: @input_width;
    margin-right: 10px;
  }
  .value-input-tetxtarea {
    max-width: 1195px;
    margin-right: 10px;
  }
  .files-container {
    display: flex;
    flex-wrap: wrap;
  }
  .bottom-btn {
    position: fixed;
    bottom: 0px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-top: 1px solid #ccc;
    left: 0;
    right: 0;
    background: #fff;
  }
}
</style>
